export const usZipRegex: RegExp = /^\d{5}(?:-\d{4})?$/;
export const canadaPinRegex: RegExp = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] \d[ABCEGHJ-NPRSTV-Z]\d$/;
export const error_status_regex: RegExp =/status code (\d{3})/;
export const status_code_match: RegExp = /^4\d{2}$/;